import { C } from "../consumer/data";
export { C };
export { Serif, Label, Avatar } from "../consumer/ui";

export const Panel = ({ children, style, ...rest }) => (
  <div style={{ background: "#fff", border: "1px solid rgba(26,30,36,0.08)", borderRadius: 12, padding: 20, ...style }} {...rest}>{children}</div>
);

export const Kpi = ({ label, value, accent, mono }) => (
  <div style={{ background: "#fff", border: "1px solid rgba(26,30,36,0.08)", borderRadius: 10, padding: "16px 18px", flex: 1, minWidth: 0 }}>
    <div style={{ fontSize: 10, letterSpacing: "0.14em", textTransform: "uppercase", color: C.slate, fontFamily: "'JetBrains Mono', monospace" }}>{label}</div>
    <div style={{ marginTop: 8, fontSize: 26, fontWeight: 700, color: accent || C.ink, letterSpacing: "-0.02em", fontVariantNumeric: "tabular-nums", fontFamily: mono ? "'JetBrains Mono', monospace" : undefined }}>{value}</div>
  </div>
);

export const Chip = ({ children, color = C.slate, solid }) => (
  <span style={{ display: "inline-block", padding: "3px 10px", borderRadius: 999, fontSize: 11, fontWeight: 700, background: solid ? color : `${color}18`, color: solid ? "#fff" : color, whiteSpace: "nowrap" }}>{children}</span>
);

export const StatusChip = ({ status }) => {
  const map = { active: C.green, lead: C.amber, Sent: C.green, Draft: C.slate, Scheduled: C.amber };
  return <Chip color={map[status] || C.slate}>{status}</Chip>;
};

export const Table = ({ head, children }) => (
  <div style={{ overflowX: "auto", border: "1px solid rgba(26,30,36,0.08)", borderRadius: 12, background: "#fff" }}>
    <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}>
      <thead>
        <tr>{head.map((h) => (
          <th key={h} style={{ textAlign: "left", padding: "12px 16px", fontSize: 10, letterSpacing: "0.12em", textTransform: "uppercase", color: C.slate, fontFamily: "'JetBrains Mono', monospace", borderBottom: "1px solid rgba(26,30,36,0.08)", whiteSpace: "nowrap" }}>{h}</th>
        ))}</tr>
      </thead>
      <tbody>{children}</tbody>
    </table>
  </div>
);

export const Td = ({ children, style }) => (
  <td style={{ padding: "13px 16px", borderTop: "1px solid rgba(26,30,36,0.06)", color: C.ink, ...style }}>{children}</td>
);

export const Battery = ({ pct }) => (
  <span style={{ display: "inline-flex", alignItems: "center", gap: 6 }}>
    <span style={{ width: 44, height: 6, background: "#eee", borderRadius: 3, overflow: "hidden", display: "inline-block" }}>
      <span style={{ display: "block", height: "100%", width: `${pct}%`, background: pct < 20 ? C.red : pct < 50 ? C.amber : C.green }} />
    </span>
    <span style={{ fontSize: 11, fontFamily: "'JetBrains Mono', monospace", color: C.slate }}>{pct}%</span>
  </span>
);
